import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/seller"

export const List = async (values) => {
    return await axiosInstance(options).post(`${path}/list`, values);
}

export const EditDetails = async (values) => {
    return await axiosInstance(options).put(`${path}/edit-details`, values);
}

export const Delete = async (values) => {
    if (values && values.ids) {
        return await axiosInstance(options).delete(`${path}/delete-user?ids=${encodeURIComponent(JSON.stringify(values.ids))}`, { data: values });
    }
    return await axiosInstance(options).delete(`${path}/delete-user?_id=${values?._id || values}`, values);
}

export const Details = async (value) => {
    return await axiosInstance(options).get(`${path}/get-details?_id=${value._id}`);
}

export const Status = async (values) => {
    return await axiosInstance(options).patch(`${path}/block-user`, values)
}

export const Verification = async (values) => {
    return await axiosInstance(options).patch(`${path}/update-verification`, values)
}

export const UpdateInvoiceVisibility = async (values) => {
    return await axiosInstance(options).patch(`${path}/update-invoice-visibility`, values)
}

export const payementDetails = async (value) => {
    return await axiosInstance(options).post(`${path}/payment-details`, value);
}
export const EditBusinessDetails = async (values) => {
    return await axiosInstance(options).put(`${path}/edit-business-details`, values);
}
export const EditKYCDetails = async (values) => {
    return await axiosInstance(options).put(`${path}/edit-kyc-details`, values);
}
export const endStream = async (values) => {
    return await axiosInstance(options).post(`admin/stream/end-stream`, values);
}